import React from "react";

import "./shoppingListItem.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp, faArrowDown } from "@fortawesome/free-solid-svg-icons";

const ShoppingListItem = (props) => {
  return (
    <div className="shoppingListItem-Container">
      <img
        src={props.picture}
        alt="Shopping cart"
        height="38"
        width="64"
        className="shoppingListItem-ItemImage"
      ></img>
      <div className="shoppingListItem-InnerContainer">
        <h3> Qty: </h3>
        <input className="shoppingListItem-Quantity" value={props.quantity} />
        <div className="shoppingListItem-ArrowContainer">
          <button
            className="shoppingList-ArrowButton"
            onClick={() => props.addToCart(props.id)}
          >
            <FontAwesomeIcon icon={faArrowUp} />
          </button>
          <button
            className="shoppingList-ArrowButton"
            onClick={() => props.removeFromCart(props.id)}
          >
            <FontAwesomeIcon icon={faArrowDown} />
          </button>
        </div>
      </div>
      <h3 className="shoppingListItem-Title"> {props.title} </h3>
      <h3 className="shoppingListItem-Description"> {props.description} </h3>
      <h3 className="shoppingListItem-Cost"> Cost: ${props.cost}</h3>
      <button
        onClick={() => props.removeFromCart(props.id)}
        className="shoppingListItem-Remove"
      >
        X
      </button>
    </div>
  );
};

export default ShoppingListItem;
